import {
  TicketStatesTransferring,
  TicketStatesReceiving,
  TicketStatesGlobal,
} from '../../ticket/ticket.constants';

const {
  ACCEPT_OUTGOING_REQUEST,
  FINANCES_VERIFIED,
  RECEIVED_OUTGOING_REQUEST,
  REJECTED_REQUEST,
  REQUEST_DATA_COMPLETED,
  TRANSACTION_DATA_COMPLETE,
  TRANSACTION_DATA_SENT_VIA_FAX,
  TRANSACTION_DATA_SENT,
} = TicketStatesTransferring;

const {
  ALL_DOCUMENTS_SENT,
  BALANCE_LIST_DATA_RECEIVED,
  BALANCE_LIST_DOCUMENT_RECEIVED,
  BALANCE_LIST_WITHDRAWN,
  CLOSED_BY_CUSTOMER,
  DOCUMENT_SENT,
  DOCUMENT_SENT_VIA_FAX,
  DOCUMENT_SENDING_STARTED,
  INITIALIZATION_CONFIRMED_BY_USER,
  RECEIVED_REJECTION,
  REMINDER_SENT_VIA_FAX,
  REQUEST_FORM_FILLED,
  SENT_REQUEST_TO_TRANSFERRING,
  TRANSACTION_DATA_RECEIVED,
  VERIFIED_FINANCES,
  WARRANT_SIGNED,
  DEPOT_TRANSFER_STARTED,
  DEPOT_TRANSFER_COMPLETED,
  DEPOT_TRANSFER_CANCELED,
} = TicketStatesReceiving;

const { REMINDER_SENT, REQUEST_COMPLETED, KWS_ORDER_COMPLETED } =
  TicketStatesGlobal;

export const TicketListBreadcrumbs = {
  receiving: [
    'breadcrumbs.receiving.title',
    'breadcrumbs.receiving.tickets.title',
  ],
  transferring: [
    'breadcrumbs.transferring.title',
    'breadcrumbs.transferring.tickets.title',
  ],
};

export const TicketStatusClassName = {
  [ACCEPT_OUTGOING_REQUEST]: 'chart__blue-light',
  [ALL_DOCUMENTS_SENT]: 'chart__green',
  [BALANCE_LIST_DATA_RECEIVED]: 'chart__yellow',
  [BALANCE_LIST_DOCUMENT_RECEIVED]: 'chart__red',
  [CLOSED_BY_CUSTOMER]: 'chart__yellow',
  [DOCUMENT_SENT]: 'chart__green-light',
  [DOCUMENT_SENT_VIA_FAX]: 'chart__green-light',
  [DOCUMENT_SENDING_STARTED]: 'chart__green-dark',
  [FINANCES_VERIFIED]: 'chart__green',
  [INITIALIZATION_CONFIRMED_BY_USER]: 'chart__gray',
  [RECEIVED_OUTGOING_REQUEST]: 'chart__red',
  [RECEIVED_REJECTION]: 'chart__red',
  [REJECTED_REQUEST]: 'chart__red',
  [REQUEST_COMPLETED]: 'chart__blue',
  [KWS_ORDER_COMPLETED]: 'chart__gray',
  [REQUEST_DATA_COMPLETED]: 'chart__yellow',
  [REQUEST_FORM_FILLED]: 'chart__blue',
  [SENT_REQUEST_TO_TRANSFERRING]: 'chart__gray',
  [TRANSACTION_DATA_COMPLETE]: 'chart__green',
  [TRANSACTION_DATA_RECEIVED]: 'chart__red',
  [TRANSACTION_DATA_SENT_VIA_FAX]: 'chart__green',
  [TRANSACTION_DATA_SENT_VIA_FAX]: 'chart__green',
  [TRANSACTION_DATA_SENT]: 'chart__green',
  [TRANSACTION_DATA_SENT]: 'chart__green',
  [VERIFIED_FINANCES]: 'chart__yellow',
  [WARRANT_SIGNED]: 'chart__blue-light',
  [DEPOT_TRANSFER_STARTED]: 'chart__blue',
  [DEPOT_TRANSFER_CANCELED]: 'chart__red',
  [DEPOT_TRANSFER_COMPLETED]: 'chart__gray',
};

export const TicketTableStatusFilter = {
  transferring: {
    // Closed tickets (which cannot be edited)
    closed: {
      [REQUEST_COMPLETED]: {
        className: TicketStatusClassName[REQUEST_COMPLETED],
      },
      [REJECTED_REQUEST]: {
        className: TicketStatusClassName[REJECTED_REQUEST],
      },
      [CLOSED_BY_CUSTOMER]: {
        className: TicketStatusClassName[CLOSED_BY_CUSTOMER],
      },
      [FINANCES_VERIFIED]: {
        className: TicketStatusClassName[FINANCES_VERIFIED],
        aggregatedStates: [
          TRANSACTION_DATA_SENT,
          TRANSACTION_DATA_SENT_VIA_FAX,
        ],
      },
    },

    // Active tickets (which can be edited)
    active: {
      [RECEIVED_OUTGOING_REQUEST]: {
        className: TicketStatusClassName[RECEIVED_OUTGOING_REQUEST],
      },
      [ACCEPT_OUTGOING_REQUEST]: {
        className: TicketStatusClassName[ACCEPT_OUTGOING_REQUEST],
      },
      [REQUEST_DATA_COMPLETED]: {
        className: TicketStatusClassName[REQUEST_DATA_COMPLETED],
      },
      [TRANSACTION_DATA_COMPLETE]: {
        className: TicketStatusClassName[TRANSACTION_DATA_COMPLETE],
      },
    },
  },
  receiving: {
    // Closed tickets (which cannot be edited)
    closed: {
      [REQUEST_COMPLETED]: {
        className: TicketStatusClassName[REQUEST_COMPLETED],
      },
      [KWS_ORDER_COMPLETED]: {
        className: TicketStatusClassName[KWS_ORDER_COMPLETED],
      },
      [CLOSED_BY_CUSTOMER]: {
        className: TicketStatusClassName[CLOSED_BY_CUSTOMER],
      },
      [RECEIVED_REJECTION]: {
        className: TicketStatusClassName[RECEIVED_REJECTION],
      },
      [DEPOT_TRANSFER_CANCELED]: {
        className: TicketStatusClassName[DEPOT_TRANSFER_CANCELED],
      },
      [DEPOT_TRANSFER_COMPLETED]: {
        className: TicketStatusClassName[DEPOT_TRANSFER_COMPLETED],
      },
    },

    // Active tickets (which can be edited)
    active: {
      [INITIALIZATION_CONFIRMED_BY_USER]: {
        className: TicketStatusClassName[INITIALIZATION_CONFIRMED_BY_USER],
      },
      [REQUEST_FORM_FILLED]: {
        className: TicketStatusClassName[REQUEST_FORM_FILLED],
      },
      [WARRANT_SIGNED]: {
        className: TicketStatusClassName[WARRANT_SIGNED],
      },
      [DEPOT_TRANSFER_STARTED]: {
        className: TicketStatusClassName[DEPOT_TRANSFER_STARTED],
      },
      [SENT_REQUEST_TO_TRANSFERRING]: {
        className: TicketStatusClassName[SENT_REQUEST_TO_TRANSFERRING],
        aggregatedStates: [
          REMINDER_SENT,
          REMINDER_SENT_VIA_FAX,
          BALANCE_LIST_WITHDRAWN,
        ],
      },
      [TRANSACTION_DATA_RECEIVED]: {
        className: TicketStatusClassName[TRANSACTION_DATA_RECEIVED],
        aggregatedStates: [BALANCE_LIST_DOCUMENT_RECEIVED],
      },
      [VERIFIED_FINANCES]: {
        className: TicketStatusClassName[VERIFIED_FINANCES],
        aggregatedStates: [BALANCE_LIST_DATA_RECEIVED],
      },
      [DOCUMENT_SENDING_STARTED]: {
        className: TicketStatusClassName[DOCUMENT_SENDING_STARTED],
      },
      [ALL_DOCUMENTS_SENT]: {
        className: TicketStatusClassName[ALL_DOCUMENTS_SENT],
      },
    },
  },
};

// Specifies the diagrams to show and the color in the ticket overview
export const TicketTableDateFilter = {
  'deadline.week': {
    className: 'chart__green-light',
  },
  'deadline.tomorrow': {
    className: 'chart__yellow',
  },
  'deadline.today': {
    className: 'chart__red',
  },
  'deadline.overdue': {
    className: 'chart__petrol',
  },
  'deadline.none': {
    className: 'chart__gray',
  },
};
